import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCircleCheck, faCircleXmark } from '@fortawesome/pro-solid-svg-icons'
import { ReactNode } from 'react'

export interface DetailsTableDataGroupValuesItem {
  icon?: IconDefinition
  label: string
  value?: string | number
}

export interface DetailsTableDataGroup {
  id: string
  icon?: IconDefinition
  iconCount?: number
  iconClassName?: string
  label?: string | ReactNode
  labelClassName?: string
  value?: string | number | ReactNode
  valueClassName?: string
  type?: 'basic' | 'iconCounter' | 'headline' | 'table' | 'list' | 'iconList' | 'iconListCols'
  values?: DetailsTableDataGroupValuesItem[]
}

export interface DetailsTableCell {
  data: DetailsTableDataGroup[]
  cellClassName?: string
  id: string
}

export interface DetailsTableRow {
  /**
   * Issue in font-awesome with the IconDefinition:
   * https://github.com/FortAwesome/react-fontawesome/issues/366
   *
   * This should've been fixed in our package versions but for some reason thin icons still have a bugged icon
   * definition. Perhaps with a future package upgrade we can use the same one. For now we'll need to cast
   * when using 'thin' icons
   */
  icon: IconDefinition
  title: string
  rowType?: unknown
  className?: string
  /** component to render for editting */
  editComponent?: ReactNode
  cells?: DetailsTableCell[]
  subRows?: DetailsTableCell[][]
}

export interface DetailsTableBooleanFieldConfig {
  icon?: IconDefinition
  class?: string
  key?: string
}

export const DETAILS_TABLE_BOOLEAN_FIELDS: Record<string, DetailsTableBooleanFieldConfig> = {
  yes: { icon: faCircleCheck, key: 'ui:yes' },
  no: { icon: faCircleXmark, key: 'ui:no' },
}
